export { default } from './CoLoginBannerProps'
